import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../../../Assets/css/staticPage.css";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const CustoMDesign = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  return (
    <div className="Custom_Designs_page">
      <div className="custom-design-banner">
        <img
          className="img-fluid"
          alt="banner"
          src={require("../../../Assets/images/custom-design/banner.png")}
        />
        <h3>
          {t("custDesign.designYr")} <br />
          {t("custDesign.withSpinosa")}
        </h3>
      </div>
      <div className="custom-design-1">
        <Container>
          <h3>{t("custDesign.visualize")}</h3>
          <p>{t("custDesign.imagine")}</p>
          <p>{t("custDesign.proportion")}</p>
        </Container>
      </div>
      <div className="custom-design-2">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={5}>
              <img
                className="img-fluid pr-md-5"
                alt="banner"
                src={require("../../../Assets/images/custom-design/personal.png")}
              />
            </Col>
            <Col md={6}>
              <h4>{t("custDesign.weDesign")}</h4>
              <p>{t("custDesign.unlike")}</p>
              <p>{t("custDesign.andIfu")}</p>
              <p>{t("custDesign.illBe")}</p>
            </Col>
          </Row>

          <Row className="align-items-center justify-content-center">
            <Col md={6}>
              <h4>{t("custDesign.unique")}</h4>
              <p>{t("custDesign.uCan")}</p>
              <p>{t("custDesign.ltdEdition")}</p>
            </Col>
            <Col md={5} className="order-first order-md-last">
              <img
                className="img-fluid pl-md-5"
                alt="banner"
                src={require("../../../Assets/images/custom-design/workshop.png")}
              />
            </Col>
          </Row>

          <Row className="align-items-center justify-content-center">
            <Col md={5}>
              <img
                className="img-fluid pr-md-5"
                alt="banner"
                src={require("../../../Assets/images/custom-design/quality.png")}
              />
            </Col>
            <Col md={6}>
              <h4>{t("custDesign.unbeatable")}</h4>
              <p> {t("custDesign.findYour")}</p>
              <p>{t("custDesign.asACerti")}</p>
              <p>{t("custDesign.thatsWhy")}</p>
              <p>{t("custDesign.andNot")}</p>
            </Col>
          </Row>

          <Row className="align-items-center justify-content-center">
            <Col md={6}>
              <h4>{t("custDesign.anInvestment")}</h4>
              <p>{t("custDesign.aSpinosa")}</p>
              <p>{t("custDesign.acquire")}</p>
              <p>{t("custDesign.buying")}</p>
              <p>{t("custDesign.andYes")}</p>
            </Col>
            <Col md={5} className="order-first order-md-last">
              <img
                className="img-fluid pl-md-5"
                alt="banner"
                src={require("../../../Assets/images/custom-design/investment.png")}
              />
            </Col>
          </Row>

          <Row className="align-items-center justify-content-center">
            <Col md={5}>
              <img
                className="img-fluid pr-md-5"
                alt="banner"
                src={require("../../../Assets/images/custom-design/insure.png")}
              />
            </Col>
            <Col md={6}>
              <h4>{t("custDesign.wantTo")}</h4>
              <p>{t("custDesign.following")}</p>
              <p>{t("custDesign.travelWith1")}</p>
              <p>
                <a href={`/${lang}/contact`} className="text-dark">
                  {t("custDesign.clickHere")}
                </a>
                {t("custDesign.askUs")}
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="custom-design-1 bg-white pt-0">
        <img
          className="img-fluid"
          alt="banner"
          src={require("../../../Assets/images/custom-design/client-img-new.jpg")}
        />
        <div className="text-center mt-5 text-black">
          <h3>{t("custDesign.shallWe")}</h3>
          <p>
            <a href={`/${lang}/contact`} className="text-dark">
              {t("custDesign.clickOn")}
            </a>
          </p>
          <p>{t("custDesign.weCan")}</p>
          <p>{t("custDesign.andRemember")}</p>
          <p>{t("custDesign.inJust")}</p>
        </div>
      </div>
    </div>
  );
};

export default CustoMDesign;
